import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getUserNotifications() {
  return fetcher.get({
    path: '/notifications/user',
  });
}

export async function updateNotification(id, data) {
  return fetcher.put({
    path: `/notifications/${id}`,
    body: data,
  });
}
